export default Backbone.Epoxy.Model.extend({
    defaults: {
        id: null,
        type: null,
        price: null,

        discount: null,
        description: null,
        hash: null,
        firstPayment: 1,
        medicalInsurance: null,
        transferType: null,
        tourCriteria: null,
        actualizeInProgress: false,
        firstPaymentDefinition: null,

        produceVisaByMerchant: null, //TODO: possible legacy - rm
        availableTransfers: null, //TODO: possible legacy - rm
        wasActualize: false, //TODO: possible legacy - rm

        tour: null,
        hotelOffer: null,
        railwayTour: null,
        similarTours: [],
    },
    computeds: {
        tourProducts: {
            deps: ['similarProducts'],
            get: (similarProducts) => _.filter(similarProducts, (similarProduct) => similarProduct.get('type') === 'TourProduct'),
        },
        product: {
            deps: ['tour', 'hotelOffer', 'railwayTour'],
            get(tour, hotelOffer, railwayTour) {
                return tour || hotelOffer || railwayTour || null;
            },
        },
        dateFrom: {
            deps: ['product'],
            get: (product) => product.get('checkInDateRange').get('from').getTime(),
        },
    },
});